import { EntDirectoryInfoName } from "./directoryInfoName";
import { EntGovernment } from "./handBooks/government";
import { EntTerritorialsUnits } from "./handBooks/territorialsUnits";

export class EntMovableProperty {
  id: number = 0;
  name: string | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  brand: string | null = null;
  model: string | null = null;
  quantity: number | null = null;
  description: string | null = null;
  condition:EntDirectoryInfoName | null = null;
  government:EntGovernment | null = null;
  territorialUnit:EntTerritorialsUnits | null = null;
  address: string | null = null;
  longitude: number | undefined = undefined;
  latitude: number | undefined = undefined;

  conditionId?: number | null = null;
  governmentId?: number | null = null;
  territorialUnitId?: number | null = null;

  territorialUnitArea:EntTerritorialsUnits | null = null;
  territorialUnitRegion:EntTerritorialsUnits | null = null;

  regionId: number | null = null
  areaId: number | null = null
}